module.exports = __webpack_public_path__ + "static/media/window-gray.6b269f2b.svg";